<template>
  <section class="dimension-card">
    <h3 class="dimension-title">
      用户业务办理榜单（TOP 20）
    </h3>
    <div class="ranking-tabs">
      <button
        v-for="tab in tabs"
        :key="tab.value"
        type="button"
        class="ranking-tab"
        :class="{ 'is-active': activeType === tab.value }"
        @click="activeType = tab.value"
      >
        {{ tab.label }}
      </button>
    </div>
    <div class="ranking-table-wrap">
      <table class="ranking-table">
        <thead>
          <tr>
            <th>序号</th>
            <th>用户名称</th>
            <th>用户类型</th>
            <th>办理业务总数</th>
            <th>办理业务类型</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, index) in visibleRows"
            :key="row.id"
          >
            <td>{{ String(index + 1).padStart(2, '0') }}</td>
            <td>{{ row.name }}</td>
            <td>{{ row.type === 'personal' ? '个人用户' : '企业用户' }}</td>
            <td>{{ row.total }}</td>
            <td>{{ row.businessTypes }}</td>
          </tr>
          <tr v-if="!visibleRows.length">
            <td
              colspan="5"
              class="empty-cell"
            >
              暂无数据
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script setup>
import { computed, onMounted, shallowRef } from 'vue'
import { getUserBusinessHandlingRanking } from '@/api/normalChannelStatistics'

const activeType = shallowRef('all')
const rankingRows = shallowRef({
  all: [],
  personal: [],
  enterprise: []
})
const tabs = [
  { label: '总榜单', value: 'all' },
  { label: '个人用户', value: 'personal' },
  { label: '企业用户', value: 'enterprise' }
]
const visibleRows = computed(() => rankingRows.value[activeType.value] || [])

function normalizeRows(rows) {
  if (!Array.isArray(rows)) return []
  return rows.map((row) => {
    const originalTotal = Number(row.originalTotal) || 0
    const productTotal = Number(row.productTotal) || 0
    const businessTypes = []
    if (originalTotal > 0) businessTypes.push(`原创作品备案:${originalTotal}`)
    if (productTotal > 0) businessTypes.push(`产品发布存证:${productTotal}`)
    return {
      id: row.id,
      name: row.name || '-',
      type: row.type,
      total: Number(row.total) || 0,
      businessTypes: businessTypes.join('，') || '-'
    }
  })
}

async function loadBusinessHandlingRanking() {
  try {
    const response = await getUserBusinessHandlingRanking()
    const data = response && response.code === 200 && response.data
      ? response.data
      : {}
    rankingRows.value = {
      all: normalizeRows(data.all),
      personal: normalizeRows(data.personal),
      enterprise: normalizeRows(data.enterprise)
    }
  } catch (error) {
    console.error('查询用户业务办理榜单失败:', error)
    rankingRows.value = { all: [], personal: [], enterprise: [] }
  }
}

onMounted(loadBusinessHandlingRanking)
</script>

<style lang="scss" scoped>
.dimension-card {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 24px 24px;
  border: 1px solid #ebeef5;
  border-radius: 2px;
  background: #fff;
}

.dimension-title {
  margin: 0 0 18px;
  color: #333;
  font-size: 18px;
  font-weight: bold;
}

.ranking-tabs {
  display: inline-flex;
  margin-bottom: 18px;
  overflow: hidden;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}

.ranking-tab {
  min-width: 104px;
  height: 38px;
  padding: 0 20px;
  border: 0;
  border-right: 1px solid #dcdfe6;
  background: #fff;
  color: #333;
  font-weight: bold;
  cursor: pointer;

  &:last-child {
    border-right: 0;
  }

  &.is-active {
    background: #1769f5;
    color: #fff;
  }
}

.ranking-table-wrap {
  width: 100%;
  overflow-x: auto;
}

.ranking-table {
  width: 100%;
  min-width: 820px;
  border-collapse: collapse;
  table-layout: fixed;
  color: #333;
  font-size: 13px;

  th,
  td {
    height: 38px;
    box-sizing: border-box;
    padding: 8px 14px;
    border-bottom: 1px solid #ebeef5;
    text-align: center;
    word-break: break-word;
  }

  th {
    height: 42px;
    background: #f0f3f7;
    font-weight: 600;
  }

  th:nth-child(1) {
    width: 9%;
  }

  th:nth-child(2) {
    width: 25%;
  }

  th:nth-child(3) {
    width: 17%;
  }

  th:nth-child(4) {
    width: 18%;
  }

  th:nth-child(5) {
    width: 31%;
  }
}

.ranking-table .empty-cell {
  height: 100px;
  color: #999;
  text-align: center;
}

@media (max-width: 768px) {
  .dimension-card {
    padding: 16px;
  }

  .dimension-title {
    font-size: 16px;
  }

  .ranking-tabs {
    display: flex;
  }

  .ranking-tab {
    flex: 1;
    min-width: 0;
    padding: 0 10px;
  }
}

@media (max-width: 480px) {
  .dimension-card {
    padding: 12px;
  }

  .ranking-tab {
    font-size: 12px;
  }
}
</style>
